import React from "react";
import { CSVLink } from "react-csv";
import { baseUrl, hostbaseUrl } from "../../../shared/baseUrl";
import { getallapplicant } from "../../../features/Applicant/applicantSlice";
import { useAppDispatch, useAppSelector } from "../../../useStore";
import { Spinners } from "../../../components/TableOptions";
import moment from "moment";

const ReportDownloader = ({ datas }) => {
  const dispatch = useAppDispatch();
  const { data, ResignApplicantisLoading } = useAppSelector((state: any) => state.applicant);



  const headers: any = [
    { label: "Date Contacted", key: "dateContacted" },
    { label: "APPLICANT NAME", key: "name" },
    { label: "GENDER", key: "gender" },
    { label: "DATE OF BIRTH", key: "dateOfBirth" },
    { label: "APPLIED ON", key: "createdAt" },
    { label: "STATUS", key: "applicationStatus" },
    { label: "RESIGNATION DATE", key: "resignedDate" },
    { label: "EMAIL", key: "email" },
    { label: "PHONE NUMBER", key: "phoneNumber" },
    { label: "AVERAGE INTERVIEW SCORE", key: "testScore" },
    { label: "WORK EXPERIENCE", key: "totalWorkExperience" },
    { label: "RELEVANT WORK EXPERIENCE", key: "relevantWorkExperience" },
    { label: "LOCATION", key: "location" },
    { label: "STARTING DATE", key: "joiningDate" },
    { label: "ID CARD", key: "verificationID" },
    { label: "TRAINING CERTIFICATE", key: "Training" },
    { label: "COMPLETION OF TRAINING", key: "COMPLETIONOFTRAINING" },
    { label: "OFFER LETTER URL", key: "offerLetterUrl" },
  ];

  const loopData: any = (data, id) => {
    const newData: any = [];
    data?.forEach((item) => {
      newData.push({
        dateContacted: moment(item?.createdAt).format("MM-DD-YYYY"),
        name: item?.firstName + ' ' + item?.LastName,
        gender: item?.gender,
        dateOfBirth: moment.utc(item?.dateOfBirth).format("MM-DD-YYYY"),
        createdAt: moment.utc(item?.createdAt).format("MM-DD-YYYY"),
        applicationStatus: item?.applicationStatus,
        resignedDate: moment.utc(item?.resignedDate).format("MM-DD-YYYY"),
        email: item?.email,
        phoneNumber: item?.phoneNumber,
        testScore: item?.InterviewLog?.interviewScore,
        totalWorkExperience: item?.totalWorkExperience,
        relevantWorkExperience: item?.relevantWorkExperience,
        location: item?.location,
        joiningDate: moment.utc(item?.Hire?.startingDate).format("MM-DD-YYYY"),
        verificationID: `${baseUrl}/${item?.verificationID}`,
        Training: `${hostbaseUrl}/certificateX27QF0rPxLljNoAq71sgROuRuJd0A40aApO_EALw_wcB=preview/${item?.id}`,
        COMPLETIONOFTRAINING: moment.utc(item?.Training?.endDate).format("MM-DD-YYYY"),
        offerLetterUrl: `${item?.offerLetterUrl}`,
      });
    });
    return newData;
  };
  const exportData = loopData(data?.data);

  const today = new Date();
  const year = today.getFullYear();
  const month = today.getMonth() + 1;
  const day = today.getDate();

  const csvdate =
    "HIRED  [" + day + "-" + month + "-" + year + "].csv";



  const handleUpdate = () => {
    const inputs = { applicationStatus: "HIRED,RESIGNED" };
    // @ts-ignore
    dispatch(getallapplicant(inputs));
  };


  return (
    <CSVLink data={exportData} headers={headers} filename={csvdate}>
      <button className="btn-download" onClick={handleUpdate}>

        {ResignApplicantisLoading ? <Spinners size={"sm"} /> :
          <div style={{
            display: "flex",
            alignItems: "center",
            gap: "5px"
          }}>
            <span>Download</span>
            <i className="fas fa-download" />
          </div>}

      </button>
    </CSVLink>
  );
};

export default ReportDownloader;

